var map = {
	"./": [
		7536
	],
	"./Aroids.svg": [
		9295,
		9295
	],
	"./ArrowDown": [
		1375,
		1375
	],
	"./ArrowDown.tsx": [
		1375,
		1375
	],
	"./ArrowLeft.svg": [
		2833,
		2833
	],
	"./ArrowRight": [
		1537,
		1537
	],
	"./ArrowRight.tsx": [
		1537,
		1537
	],
	"./Benefits.svg": [
		2355,
		2355
	],
	"./Berries.svg": [
		9494,
		9494
	],
	"./Bicycle.svg": [
		7889,
		7889
	],
	"./Bus.svg": [
		2218,
		2218
	],
	"./Bush.svg": [
		6302,
		6302
	],
	"./BushWithBerries.svg": [
		8637,
		8637
	],
	"./Car.svg": [
		2179,
		2179
	],
	"./Cereals.svg": [
		7364,
		7364
	],
	"./Clock.svg": [
		2196,
		2196
	],
	"./Close": [
		3272,
		3272
	],
	"./Close.tsx": [
		3272,
		3272
	],
	"./CrampedGreenhouse.svg": [
		8836,
		8836
	],
	"./DashedDivider.svg": [
		8237,
		8237
	],
	"./DendrologyTree.svg": [
		9015,
		9015
	],
	"./Endangered.svg": [
		8873,
		8873
	],
	"./EquipmentPlacing.svg": [
		2106,
		2106
	],
	"./Expand.svg": [
		8984,
		8984
	],
	"./Facebook.svg": [
		2330,
		2330
	],
	"./Forest.svg": [
		6960,
		6960
	],
	"./GoWombatLogo.svg": [
		4223,
		4223
	],
	"./GreenFlowers.svg": [
		1383,
		1383
	],
	"./GreenLeafs.svg": [
		7201,
		7201
	],
	"./HistoryMeaning.svg": [
		460,
		460
	],
	"./Icons": [
		5956,
		5956
	],
	"./Icons.tsx": [
		5956,
		5956
	],
	"./Instagram.svg": [
		9259,
		9259
	],
	"./Location.svg": [
		9601,
		9601
	],
	"./LocationPin": [
		2861,
		2861
	],
	"./LocationPin.tsx": [
		2861,
		2861
	],
	"./Logo.svg": [
		1719,
		1719
	],
	"./LogoEn.svg": [
		6586,
		6586
	],
	"./LogoSmall.svg": [
		9619,
		9619
	],
	"./LongLiving.svg": [
		2007,
		2007
	],
	"./ManagementInstructions.svg": [
		5047,
		5047
	],
	"./Medical.svg": [
		5214,
		5214
	],
	"./Menu.svg": [
		9294,
		9294
	],
	"./Miniature.svg": [
		3796,
		3796
	],
	"./NaturalStatus.svg": [
		2782,
		2782
	],
	"./NotFound.svg": [
		147,
		147
	],
	"./PathBorders.svg": [
		677,
		677
	],
	"./Phone.svg": [
		7548,
		7548
	],
	"./Pin.svg": [
		3721,
		3721
	],
	"./QRCode.svg": [
		8055,
		8055
	],
	"./RedFlower.svg": [
		1405,
		1405
	],
	"./RedFlowers.svg": [
		2496,
		2496
	],
	"./Rose.svg": [
		2544,
		2544
	],
	"./Sallow.svg": [
		6928,
		6928
	],
	"./Seedling.svg": [
		413,
		413
	],
	"./SporePlant.svg": [
		8993,
		8993
	],
	"./Succulents.svg": [
		3896,
		3896
	],
	"./Ticket": [
		7238,
		7238
	],
	"./Ticket.tsx": [
		7238,
		7238
	],
	"./Tropical.svg": [
		8072,
		8072
	],
	"./Tulip.svg": [
		3814,
		3814
	],
	"./index": [
		7536
	],
	"./index.tsx": [
		7536
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8021;
module.exports = webpackAsyncContext;